module.exports = __webpack_public_path__ + "static/media/Group 7-A4.a92dc454.svg";